import { render, staticRenderFns } from "./Roteirizacao.vue?vue&type=template&id=69a37546&"
import script from "./Roteirizacao.vue?vue&type=script&lang=js&"
export * from "./Roteirizacao.vue?vue&type=script&lang=js&"
import style0 from "./Roteirizacao.vue?vue&type=style&index=0&id=69a37546&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports